module.exports = __webpack_public_path__ + "static/media/selo.ce642094.png";